import { useMemo } from "react";
import settingsRoutes from "../../utils/account/paths";
import AdminAccountLayout from "../../components/Layouts/Account";
import { Link, useParams } from "react-router-dom";

const ManageAccountPage = () => {
  const params = useParams();

  const activeRoute = useMemo(() => {
    const nextPath = params['*']
      ? (params['*'] as string)
      : "";

    const settings = settingsRoutes.find(
      (settingsRoute) => settingsRoute.path === nextPath
    );

    return settings;
  }, [params]);

  const RouteComponent = () => {
    if (activeRoute) return activeRoute.Component;

    return (
      <div className="text-center text-3xl text-gray-400">
        Page not found {params.settingsRoute}
      </div>
    );
  };

  return (
    <>
      <title>{activeRoute?.title ?? "My Account"}</title>
      <AdminAccountLayout title="My Account">
        <div className="border-b border-gray-750 mb-10">
          <div className="max-w-5xl mx-auto flex py-4">
            {settingsRoutes.map(
              ({ path: crPath, title: crTitle }: any, index) => (
                <Link key={index} to={`/account/${crPath}`}>
                  <div
                    className={`${
                      crPath ===
                      activeRoute?.path
                        ? "text-white"
                        : "text-gray-450"
                    }  hover:text-white mr-4`}
                  >
                    {crTitle}
                  </div>
                </Link>
              )
            )}
          </div>
        </div>
        <RouteComponent />
      </AdminAccountLayout>
    </>
  );
};

export default ManageAccountPage;
